import chipStatusColor from './chipStatusColor'
import statusName from './statusName'

const documentationLinks = {
  chipStatusColor,
  statusName,
}

export default documentationLinks
